import React from "react";

import { difference } from "lodash";

import Stack from "@busbud/design-system-components/dist/Stack";

import type { TripOption } from "@app/types/results-types";

import { ClassCard } from "./class-card";
import { SingleClassOption } from "./single-class-option";
import { SelectableCardSkeleton } from "../../../components/selectable-card/skeleton";

// Maintains reference between renders
const EMPTY_ARR: any[] = [];

interface Props {
  trip_classes: TripOption[][];
  onSelect: (trip_id: string) => void;
  selected_trip_id?: string;
  loading?: boolean;
  is_single_class_option?: boolean;
}

const Skeleton = React.memo(() => (
  <Stack
    spacing={3}
    direction="column"
    display="flex"
    justifyContent="center"
    alignItems="center"
  >
    <SelectableCardSkeleton selected />
    <SelectableCardSkeleton />
    <SelectableCardSkeleton />
  </Stack>
));

export const ClassesList: React.FC<Props> = ({
  trip_classes,
  loading,
  selected_trip_id,
  onSelect,
  is_single_class_option
}) => {
  const is_empty = !trip_classes.length;

  if (loading || is_empty) {
    return <Skeleton />;
  }

  if (is_single_class_option) {
    const first_trip_option = trip_classes[0]?.[0];
    return (
      // @ts-expect-error TS18048 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
      <SingleClassOption amenities={first_trip_option.amenities || EMPTY_ARR} />
    );
  }

  return (
    <Stack spacing={2} direction="column">
      {trip_classes.map((trip_class, index) => {
        const preceding_class = trip_classes[index - 1]?.[0];
        const first_trip_option = trip_class[0];
        const selected = trip_class.some(
          trip_option => trip_option.trip_id === selected_trip_id
        );
        const preceding_class_name = !!preceding_class?.amenities?.length
          ? preceding_class.class_name
          : undefined;

        return (
          <ClassCard
            // @ts-expect-error TS18048 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
            key={first_trip_option.class_xid}
            selected={selected}
            // @ts-expect-error TS2322 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
            trip_class={first_trip_option}
            // @ts-expect-error TS18048 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
            min_price_in_cents={first_trip_option.price_in_cents}
            onSelect={onSelect}
            // @ts-expect-error TS18048 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
            disabled={first_trip_option.is_sold_out}
            preceding_class_name={preceding_class_name}
            amenities={difference(
              // @ts-expect-error TS18048 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
              first_trip_option.amenities as unknown as string[],
              (preceding_class?.amenities as unknown as string[]) || EMPTY_ARR
            )}
          />
        );
      })}
    </Stack>
  );
};
